/**
 * Product Image Interface
 * Matches backend ProductImage interface
 */
export interface ProductImage {
  id: string;
  thumbnail: string;
  medium: string;
  large: string;
  originalName: string;
  size: number;
  order: number;
  createdAt: string | Date;
}

/**
 * Get image URL helper
 */
export const getImageUrl = (path: string, apiUrl: string = process.env.REACT_APP_API_URL || 'http://localhost:3001'): string => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // Ensure there's a slash between API URL and path
  const separator = path.startsWith('/') ? '' : '/';
  return `${apiUrl}${separator}${path}`;
};
